import * as types from './mutation_types'
import { filter, map } from 'lodash'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
      updated: null,
      violations: null,
      brands: [],
      brandsLoading: false,
      languages: [],
      languagesLoading: false,
      translationError: '',
      translation: null,
      translationLoading: false,
      isLoadingGameFileVersion: false,
      gameFileVersionError: '',
      gameFileVersionViolations: null,
      gameFileVersions: [],
      gameFileVersionsView: {},
      gameFileVersionsTotalItems: 0,
      selectedBrandTab: null,
      publishedGameFile: null,
      publishGameFileError: '',
      publishGameFileLoading: false
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_RETRIEVED] (state, retrieved) {
    Object.assign(state, { retrieved })
  },

  [types.SET_UPDATED] (state, updated) {
    Object.assign(state, { error: '', updated, violations: null })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.SET_LANGUAGES] (state, items) {
    Object.assign(state, { languages: items })
  },

  [types.SET_LANGUAGES_TOGGLE_LOADING] (state) {
    Object.assign(state, { languagesLoading: !state.languagesLoading })
  },

  [types.SET_TRANSLATION] (state, translation) {
    Object.assign(state, { translation })
  },

  [types.SET_TRANSLATION_TOGGLE_LOADING] (state) {
    Object.assign(state, { translationLoading: !state.translationLoading })
  },

  [types.SET_TRANSLATION_ERROR] (state, error) {
    Object.assign(state, { translationError: error })
  },

  [types.TOGGLE_GAME_FILE_VERSION_LOADING] (state) {
    Object.assign(state, { isLoadingGameFileVersion: !state.isLoadingGameFileVersion })
  },

  [types.GAME_FILE_VERSION_ERROR] (state, error) {
    Object.assign(state, { gameFileVersionError: error })
  },

  [types.GAME_FILE_VERSION_ERROR_SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { gameFileVersionViolations: violations })
  },

  [types.SET_GAME_FILE_VERSIONS] (state, items) {
    Object.assign(state, { gameFileVersions: items })
  },

  [types.SET_GAME_FILE_VERSIONS_VIEW] (state, view) {
    Object.assign(state, { gameFileVersionsView: view })
  },

  [types.SET_GAME_FILE_VERSIONS_TOTAL_ITEMS] (state, total) {
    Object.assign(state, { gameFileVersionsTotalItems: total })
  },

  [types.UPLOADED_GAME_FILE_VERSION] (state, item) {
    state.gameFileVersionsTotalItems += 1
    state.gameFileVersions = [...state.gameFileVersions, item]
  },

  [types.DELETED_GAME_FILE_VERSION] (state, gameFileVersionId) {
    state.gameFileVersionsTotalItems -= 1
    state.gameFileVersions = filter(state.gameFileVersions, (version) => version['@id'] !== gameFileVersionId)
  },

  [types.SET_BRANDS] (state, items) {
    Object.assign(state, { brands: items })
  },

  [types.SET_BRANDS_TOGGLE_LOADING] (state) {
    Object.assign(state, { brandsLoading: !state.brandsLoading })
  },

  [types.SET_SELECTED_BRAND_TAB] (state, item) {
    Object.assign(state, { selectedBrandTab: item })
  },

  [types.PUBLISHED_GAME_FILE] (state, item) {
    if (item) {
      state.gameFileVersions = map(state.gameFileVersions, (x) => {
        if (x.game === item.game && x.brand === item.brand) {
          if (x.id === item.id) {
            x.published = true
          } else {
            x.published = false
          }
        }
        return x
      })
    }

    Object.assign(state, { publishedGameFile: item })
  },

  [types.PUBLISH_GAME_FILE_ERROR] (state, error) {
    Object.assign(state, { publishGameFileError: error })
  },

  [types.PUBLISH_GAME_FILE_TOGGLE_LOADING] (state) {
    Object.assign(state, { publishGameFileLoading: !state.publishGameFileLoading })
  }
}
